// extracted by mini-css-extract-plugin
export default {"marketingImage2Items":"marketingImage2Items--sTM3i","marketingImage1ItemContainer":"marketingImage1ItemContainer--ebM3u","marketingImage1Item":"marketingImage1Item--VEiPR"};